import get from 'lodash/get'
import {
    FormattedBookingTypeData,
    BookingTypeStringsEnum,
} from '../../../../models/property-details-page/booking-type-model'

const isInquiryButtonVisible = ({ bookingType }: { bookingType: FormattedBookingTypeData | null }): boolean => {
    if (!bookingType) {
        return false
    }
    const type: string | null = get(bookingType, 'subType.type')
    return type === BookingTypeStringsEnum.INQUIRY
}

export default isInquiryButtonVisible
